import { useState } from 'react';
import { StageContainer } from '../features/pipelines/Stages/componentes';
import { useGetPipelineInfoQuery } from '../api/pipelineApi';
import { UploadEmpresaButton } from '../features/empresas/UploadEmpresaFile/components';
import { Link } from 'react-router';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../api/auth/authSlice';
import { CircularProgress } from '@mui/joy';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

export function PipelineLayout() {
    const [estadoFilter, setEstadoFilter] = useState<string>("Activa");
    const [showFilters, setShowFilters] = useState(false);
    const user = useSelector(selectCurrentUser);

    const { data: pipelineInfo, isLoading, isFetching } = useGetPipelineInfoQuery(estadoFilter, { refetchOnMountOrArgChange: true });

    const totalCols = pipelineInfo?.stages.length;

    return (
        <div className="w-full h-full flex flex-col">

            {/* Controles */}
            <div className="flex justify-between m-2 h-14 p-2 ">
                <UploadEmpresaButton />
                
                {user?.role === "Administrador" && (<>
                <div className="">
                    <Link to={"/pipeline/editar"}>
                        <button 
                            className="border-2 border-gray-300 rounded h-[30px] w-[30px] flex justify-center items-center hover:bg-gray-100">
                            <EditRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
                        </button>
                    </Link>
                </div>
                </>)}
            </div>

            <div className="border-0 border-green-800 mx-2 px-2">
                <div className="flex items-center">
                    <p className="font-semibold text-sm">Filtros</p>
                    <div className={`flex items-center cursor-pointer transition-all duration-300 ${showFilters ? "rotate-180": "rotate-0"}`} onClick={() => setShowFilters(!showFilters)}>
                        <KeyboardArrowDownRoundedIcon sx={{ height: 20, width: 20}} />
                    </div>
                </div>
                <div className={`flex gap-2 items-center ${showFilters ? "" : "hidden"}`}>
                    <label className="font-semibold text-gray-600 text-sm">Estado: </label>
                    <select 
                        onChange={(e) => setEstadoFilter(e.target.value)}
                        className="border-2 border-gray-300 rounded text-sm font-semibold text-gray-600"
                        name="frecuenciaVisita">
                        <option value="Activa">Activa</option>
                        <option value="Inactiva">Inactiva</option>
                        <option value="Nueva">Nueva</option>
                    </select>
                </div>
            </div>

            {/* Contenedor del embudo */}
            {isLoading || isFetching
            ?
            <div className="w-full flex justify-center items-center flex-1">
                <CircularProgress />
            </div>
            :
            <div className={`m-2 grid ${`grid-cols-5`} gap-2 p-2 overflow-hidden flex-1`}>
                {/* Etapa */}
                {pipelineInfo?.stages.map((stage, index) => (
                    <StageContainer 
                        key={index}
                        stage={stage}/>
                ))}

            </div>
            }
        </div>
    );
}
